import { toDisplayString as _toDisplayString, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, resolveComponent as _resolveComponent, withModifiers as _withModifiers, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-60d7b562")

_pushScopeId("data-v-60d7b562")
const _hoisted_1 = { class: "wrap" }
const _hoisted_2 = { class: "tab" }
const _hoisted_3 = { class: "list-wrap" }
const _hoisted_4 = { class: "list" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_d_switch_table_item = _resolveComponent("d-switch-table-item")

  return (_openBlock(), _createBlock("div", {
    class: "d-switch-table-view-root",
    onClick: _cache[3] || (_cache[3] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.hideMe && _ctx.hideMe(...args)), ["self"]))
  }, [
    _createVNode("div", _hoisted_1, [
      _createVNode("div", _hoisted_2, [
        _createVNode("div", {
          class: ["tab-item", { active: _ctx.selectedIndex === 'G002' }],
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.changeIndex('G002')))
        }, _toDisplayString(_ctx.iN('common.baccarat')), 3),
        _createVNode("div", {
          class: ["tab-item", { active: _ctx.selectedIndex === 'G003' }],
          onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.changeIndex('G003')))
        }, _toDisplayString(_ctx.iN('common.dragontiger')), 3)
      ]),
      _createVNode("div", _hoisted_3, [
        _createVNode("div", _hoisted_4, [
          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.listData, (desk) => {
            return (_openBlock(), _createBlock(_component_d_switch_table_item, {
              class: "list-item",
              showSelected: _ctx.showSelected,
              isClicked: desk.id === _ctx.isCurrentClicked,
              key: desk.id,
              mdata: desk,
              onEnterTable: _ctx.onSelectTable,
              onClick: ($event: any) => (_ctx.clickedItem(desk.id))
            }, null, 8, ["showSelected", "isClicked", "mdata", "onEnterTable", "onClick"]))
          }), 128))
        ])
      ])
    ])
  ]))
})